import store from '../store/store'
import Login from '@/views/subbrand/login.vue'
import Layout from '@/views/subbrand/layout.vue'
import SubbrandList from '@/views/subbrand/subbrandList.vue'
import DataLoader from '@/views/subbrand/dataloader.vue'
import Nosubbrand from '@/views/subbrand/noSubbrand.vue'
import CreateSubbrand from '@/views/subbrand/createSubbrand.vue'
import EditSubbrand from '@/views/subbrand/editSubbrand.vue'
import Overview from '@/views/subbrand/overview.vue'
import SubbrandSetup from '@/views/subbrand/subbrandSetupForm.vue'

import ChannelLayout from '@/views/channel/channelLayout.vue'
import ChannelDataloader from '@/views/channel/channelDataloader.vue'
import ChannelList from '@/views/channel/channelList.vue'
import ChannelOverview from '@/views/channel/channelOverview.vue'
import ChannelConfig from '@/views/channel/channelConfigForm.vue'

import CTLayout from '@/views/customization/layout.vue'
import CTDataloader from '@/views/customization/dataloader.vue'
import CustTabs from '@/views/customization/cust.vue'
import Features from '@/views/customization/features.vue'
import Text from '@/views/customization/text.vue'
import Design from '@/views/customization/design.vue'

const routes = [{
  path: '/',
  exact: 'true',
  name: 'layout',
  title: 'layout',
  component: Layout,
  beforeEnter: (to, from, next) => {
    store.state.appStore.showHeaderText = true
    store.state.appStore.isNewDesign = false
    next();
  },
  children: [{
      path: '/login',
      name: 'login',
      title: 'login',
      component: Login,
      beforeEnter: (to, from, next) => {
        store.state.appStore.showHeaderText = true
        store.state.appStore.isNewDesign = false
        next();
      }
    },
    {
      path: 'dataloader',
      name: 'dataloader',
      title: 'dataloader',
      component: DataLoader,
      beforeEnter: (to, from, next) => {
        store.state.appStore.showHeaderText = true
        store.state.appStore.isNewDesign = false
        next();
      }
    },
    {
      path: 'noSubbrand',
      name: 'noSubbrand',
      title: 'noSubbrand',
      component: Nosubbrand
    },
    {
      path: 'list',
      name: 'list',
      title: 'list',
      component: SubbrandList,
      beforeEnter: (to, from, next) => {
        store.state.appStore.showHeaderText = true
        store.state.appStore.isNewDesign = false
        next();
      }
    },
    {
      path: 'createSubbrand',
      name: 'createSubbrand',
      title: 'createSubbrand',
      component: CreateSubbrand
    },
    {
      path: 'editSubbrand',
      name: 'editSubbrand',
      title: 'editSubbrand',
      component: EditSubbrand
    },
    {
      path: 'overview',
      name: 'overview',
      title: 'overview',
      component: Overview,
      beforeEnter: (to, from, next) => {
        store.state.appStore.showHeaderText = true
        store.state.appStore.isNewDesign = false
        next();
      }
    },
    {
      path: 'subbrandSetup',
      name: 'subbrandSetup',
      title: 'subbrandSetup',
      component: SubbrandSetup,
      beforeEnter: (to, from, next) => {
        store.state.appStore.showHeaderText = true
        store.state.appStore.isNewDesign = true
        store.state.appStore.activeMainNav = 'setup'
        next();
      }
    },
    {
      path: '/channel',
      exact: 'true',
      name: 'channelLayout',
      title: 'channelLayout',
      component: ChannelLayout,
      children: [{
        path: 'channelDataloader',
        exact: 'true',
        name: 'channelDataloader',
        title: 'channelDataloader',
        component: ChannelDataloader
      }, {
        path: 'channelList',
        exact: 'true',
        name: 'channelList',
        title: 'channelList',
        component: ChannelList
      }, {
        path: 'channelOverview',
        exact: 'true',
        name: 'channelOverview',
        title: 'channelOverview',
        component: ChannelOverview
      }, {
        path: 'channelConfig',
        exact: 'true',
        name: 'channelConfig',
        title: 'channelConfig',
        component: ChannelConfig
      }]
    },
    {
      path: '/customization',
      exact: 'true',
      name: 'ctLayout',
      title: 'ctLayout',
      component: CTLayout,
      beforeEnter: (to, from, next) => {
        store.state.appStore.showHeaderText = false
        store.state.appStore.isNewDesign = window.APPCONFIG.appUXVersion == '1.1' ? true : false;
        store.state.appStore.activeMainNav = 'configure'
        next();
      },
      children: [{
          path: 'ctDataloader',
          exact: 'true',
          name: 'ctDataloader',
          title: 'ctDataloader',
          component: CTDataloader
        },
        {
          path: 'custTabs',
          exact: 'true',
          name: 'custTabs',
          title: 'custTabs',
          component: CustTabs
        },
        {
          path: 'features',
          exact: 'true',
          name: 'features',
          title: 'features',
          component: Features
        },
        {
          path: 'text',
          exact: 'true',
          name: 'text',
          title: 'text',
          component: Text
        },
        {
          path: 'design',
          exact: 'design',
          name: 'design',
          title: 'design',
          component: Design
        }
      ]
    }
  ]
}]

export default routes